import Auth from './auth';

export default function AuthInterceptor(
  $q,
  $window,
  $injector,
  $timeout
) {
  'ngInject';

  let goToLoginPage = function () {
    $window.location.href = '/home/';
  };

  return {
    request: function (config) {
      config.headers = config.headers || {};
      const configPromise = $q.defer();
      if (config.url.indexOf("amazonaws.com") == -1) {
        config.headers.Authorization = Auth.getAuthorizationHeader();
      }
      configPromise.resolve(config);
      return configPromise.promise;
    },
    requestError: function (rejection) {
      console.log('Got request error:' + rejection); // eslint-disable-line
      return $q.reject(rejection);
    },
    responseError: function (response) {
      //If we are being throttled retry the request after a timeout and return in a promise
      if (response.status === 429) {
        let def = $q.defer();
        $timeout(function () {
          let $http = $injector.get('$http');
          return $http(response.config).then(
            function (response) {
              return def.resolve(response);
            },
            function (response) {
              return def.reject(response);
            }
          );
        }, 3000);

        return def.promise;
      } else if (response.status === 401) {
        goToLoginPage();
      }
      return $q.reject(response);
    }
  };
}